import { useState } from "react";
import { Link, NavLink, useNavigate } from "react-router-dom";

const navItems = [
  { label: "首页", to: "/" },
  { label: "剧情介绍", to: "/category/plot" },
  { label: "角色分析", to: "/category/character" },
  { label: "最新资讯", to: "/category/news" },
  { label: "关于", to: "/about" },
];

function BrandLogo() {
  return (
    <Link to="/" className="flex items-center gap-2.5 cursor-pointer shrink-0">
      <span className="w-10 h-10 rounded-lg bg-primary-500 flex items-center justify-center text-background-50">
        <i className="ri-movie-2-line text-xl"></i>
      </span>
      <span className="font-heading font-bold text-lg text-foreground-950 leading-none">
        年轻的母亲<span className="text-accent-600">3</span>
      </span>
    </Link>
  );
}

export default function SiteHeader() {
  const [menuOpen, setMenuOpen] = useState(false);
  const navigate = useNavigate();

  return (
    <header className="sticky top-0 z-50 w-full bg-background-50/95 backdrop-blur border-b border-background-200">
      <div className="w-full px-4 md:px-8">
        <div className="flex items-center justify-between h-16 md:h-[72px]">
          <BrandLogo />

          <nav className="hidden md:flex items-center gap-1">
            {navItems.map((item) => (
              <NavLink
                key={item.to}
                to={item.to}
                end={item.to === "/"}
                className={({ isActive }) =>
                  `px-4 py-2 rounded-md text-[15px] transition-colors cursor-pointer whitespace-nowrap ${
                    isActive
                      ? "text-primary-700 font-medium bg-primary-50"
                      : "text-foreground-700 hover:text-primary-700 hover:bg-background-100"
                  }`
                }
              >
                {item.label}
              </NavLink>
            ))}
          </nav>

          <div className="flex items-center gap-2">
            <button
              type="button"
              onClick={() => navigate("/search")}
              aria-label="搜索"
              className="w-10 h-10 rounded-md flex items-center justify-center text-foreground-700 hover:bg-background-100 hover:text-primary-700 transition-colors cursor-pointer"
            >
              <i className="ri-search-line text-lg"></i>
            </button>
            <button
              type="button"
              onClick={() => setMenuOpen((v) => !v)}
              aria-label="菜单"
              className="md:hidden w-10 h-10 rounded-md flex items-center justify-center text-foreground-700 hover:bg-background-100 transition-colors cursor-pointer"
            >
              <i className={menuOpen ? "ri-close-line text-xl" : "ri-menu-line text-xl"}></i>
            </button>
          </div>
        </div>
      </div>

      {menuOpen && (
        <div className="md:hidden border-t border-background-200 bg-background-50 animate-fade-in">
          <nav className="px-4 py-3 flex flex-col">
            {navItems.map((item) => (
              <NavLink
                key={item.to}
                to={item.to}
                end={item.to === "/"}
                onClick={() => setMenuOpen(false)}
                className={({ isActive }) =>
                  `px-3 py-3 rounded-md text-[15px] cursor-pointer ${
                    isActive ? "text-primary-700 font-medium bg-primary-50" : "text-foreground-700"
                  }`
                }
              >
                {item.label}
              </NavLink>
            ))}
          </nav>
        </div>
      )}
    </header>
  );
}